export default __webpack_public_path__ + "static/media/CLIENTS_XS.46d8c113.svg";